export default "__VITE_ASSET__cgR0EtWE__"